export const headerDefaultProps = {
    fixed: false,
    inverted: false,
    mainId: '#main',
    footerId: '#footer',
};
